import styled from 'styled-components'

import { Button } from 'src/components'

export const Container = styled.div`
  padding: 1.6rem;
`

export const LogoutButton = styled(Button)`
  font-weight: bold;
  font-size: 1.6rem;
`
